import styled from '@emotion/styled';
import { ComponentType } from 'react';
import {colors} from '@styles/colors';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';
import {Arrow, ArrowProps} from 'react-laag';

// React 18's stricter ForwardRefExoticComponent typing breaks emotion's overload
// resolution for styled(Arrow); a plain ComponentType cast keeps ArrowProps intact.
const TypedArrow = Arrow as ComponentType<ArrowProps>;

export const TooltipContainer = styled.div`
  border-radius: ${(props) => props.theme.pillBorderRadius}px;
  background-color: ${colors.white};
  color: ${(props) => props.theme.colors.mainTextColor};
  padding: 5px 10px;
  pointer-events: none;
  white-space: break-spaces;
  max-width: 450px;
  width:100%;
  ${mq(Devices.tablet)} {
    
  }
`;

export const StyledArrow = styled(TypedArrow)`
  path {
    fill: ${(props) => props.theme.colors.white};
  }
`;

export const TooltipLayer = styled.div<{ offsetX: number; offsetY: number; display: string }>`
  transform: translate(${({ offsetX, offsetY }) => `${offsetX}px, ${offsetY}px`});
  display: ${({ display }) => (display === 'true' ? 'block' : 'none')};
  z-index: 1220;
  box-shadow: 0 0 2px 0 rgba(0,0,0,0.4);
`;
